/*
  Gymnastics Forza: quali Reel guardano i clienti.
  Quando un Reel viene aperto a tutto schermo si salva nel browser: galleria/reel, quante volte, quanto
  e' stato guardato (25/50/75/100%). La lista viene scritta sul carrello (attributo cw_reels), cosi'
  arriva sull'ordine insieme alla pubblicita' di provenienza (cw_utm_*). Nessun dato inviato a terzi.
  Non tocca il lettore (gf-reels.js): ascolta solo i video del lettore.
*/
(function () {
  if (window.gfReelTrack) return;
  window.gfReelTrack = true;

  var KEY = 'gf_rv';
  var MAX_ITEMS = 25;
  var MAX_LEN = 900;
  var MIN_SECONDS = 2;
  var STEPS = [25, 50, 75, 100];

  function load() {
    try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; }
  }
  function save(d) {
    try { localStorage.setItem(KEY, JSON.stringify(d)); } catch (e) {}
  }

  var data = load();
  var openCards = [];
  var counted = typeof WeakSet === 'function' ? new WeakSet() : null;
  var pushTimer = null;
  var lastSent = '';

  function idOf(card) {
    return (card.dataset.list || 'page') + '/' + (card.dataset.reel || ('n' + card.dataset.index));
  }

  function summary() {
    return Object.keys(data)
      .sort(function (a, b) { return data[b].t - data[a].t; })
      .slice(0, MAX_ITEMS)
      .map(function (k) { return k + ' ' + data[k].p + '% x' + data[k].n; })
      .join(', ')
      .slice(0, MAX_LEN);
  }

  function push() {
    var s = summary();
    if (!s || s === lastSent) return;
    lastSent = s;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { cw_reels: s } })
    }).catch(function () {});
  }

  function schedule() {
    clearTimeout(pushTimer);
    pushTimer = setTimeout(push, 2500);
  }

  function update(id, isNewView, pct) {
    var r = data[id] || { p: 0, n: 0, t: 0 };
    if (isNewView) r.n += 1;
    if (pct > r.p) r.p = pct;
    r.t = Date.now();
    data[id] = r;
    save(data);
    schedule();
  }

  /* quale galleria e' stata aperta: il lettore crea le slide nello stesso ordine delle card */
  document.addEventListener('click', function (event) {
    var card = event.target.closest && event.target.closest('.gf-reel');
    if (!card || event.target.closest('.gf-reel__buy')) return;
    var root = card.closest('[data-gf-reels]');
    openCards = root ? root.querySelectorAll('.gf-reel') : [card];
  }, true);

  function cardFor(video) {
    var slide = video.closest && video.closest('.gf-player__slide');
    if (!slide || !slide.parentNode) return null;
    var i = Array.prototype.indexOf.call(slide.parentNode.children, slide);
    return openCards[i] ? { card: openCards[i], slide: slide } : null;
  }

  /* i video del lettore: timeupdate non risale, quindi si ascolta in fase di cattura */
  document.addEventListener('timeupdate', function (event) {
    var video = event.target;
    if (!video.closest || !video.closest('.gf-player')) return;
    if (!video.duration || video.currentTime < MIN_SECONDS) return;
    var hit = cardFor(video);
    if (!hit) return;
    var ratio = video.currentTime / video.duration;
    var pct = 0;
    STEPS.forEach(function (s) { if (ratio * 100 >= s - 5) pct = s; });
    var isNew = false;
    if (counted && !counted.has(hit.slide)) { counted.add(hit.slide); isNew = true; }
    var id = idOf(hit.card);
    if (isNew || pct > ((data[id] && data[id].p) || 0)) update(id, isNew, pct);
  }, true);

  window.addEventListener('pagehide', push);
})();
